export const PROFILE_FIELDS = [
  {key: 'stationTitle', title: '소개'},
  {key: 'notice', title: '공지'},
  {key: 'medal', title: '메달'},
  {key: 'bornYear', title: '나이'},
  {key: 'viewCount', title: '누적 참여자'},
  {key: 'totalBroadTime', title: '방송시간'},
  {key: 'careerAward', title: '경력'},
];
